import { useState, useEffect } from "react";
import { Menu, X, Sparkles } from "lucide-react";

const links = [
  { id: "about", label: "About" },
  { id: "team", label: "Meet Us" },
  { id: "services", label: "What We Do" },
  { id: "why", label: "Why Us" },
  { id: "contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "py-2" : "py-4"
      }`}
    >
      <div className="max-w-6xl mx-auto px-4">
        <div
          className={`flex items-center justify-between rounded-full border-4 border-gray-900 bg-[#FFFAEB] px-5 py-3 transition-all ${
            scrolled ? "shadow-pop-sm" : "shadow-pop"
          }`}
        >
          <a
            href="#top"
            data-testid="navbar-logo"
            className="flex items-center gap-2 group"
          >
            <span className="w-9 h-9 rounded-full bg-[#FF6B9E] border-2 border-gray-900 flex items-center justify-center group-hover:rotate-12 transition-transform">
              <Sparkles size={18} className="text-white" />
            </span>
            <span className="font-display text-lg sm:text-xl text-gray-900 leading-none">
              The Babysitting Club
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-1">
            {links.map((l) => (
              <a
                key={l.id}
                href={`#${l.id}`}
                data-testid={`navbar-link-${l.id}`}
                className="px-4 py-2 rounded-full font-bold text-sm text-gray-900 hover:bg-[#FFD166] hover:-rotate-2 transition-all"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contact"
              data-testid="navbar-cta"
              className="ml-2 px-5 py-2 rounded-full bg-[#38E5B6] border-2 border-gray-900 font-display text-sm shadow-pop-sm btn-pop"
            >
              Book Us!
            </a>
          </nav>

          <button
            data-testid="navbar-toggle"
            onClick={() => setOpen(!open)}
            className="md:hidden w-10 h-10 rounded-full border-2 border-gray-900 bg-[#FFD166] flex items-center justify-center"
            aria-label="Toggle menu"
          >
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>

        {open && (
          <div
            data-testid="mobile-menu"
            className="md:hidden mt-3 rounded-3xl border-4 border-gray-900 bg-white p-4 shadow-pop animate-pop-in"
          >
            <div className="flex flex-col gap-2">
              {links.map((l) => (
                <a
                  key={l.id}
                  href={`#${l.id}`}
                  data-testid={`mobile-link-${l.id}`}
                  onClick={() => setOpen(false)}
                  className="px-4 py-3 rounded-2xl font-bold text-base text-gray-900 hover:bg-[#FFEBF2] transition-colors"
                >
                  {l.label}
                </a>
              ))}
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
